import "./styles.scss";
import { Row, Select } from "antd";

type SingleSelectProps = {
  options: any[];
  label: string;
  value: any;
  onChange: (value: any) => void;
  loading?: boolean;
  selectWidth?: boolean;
};

export const SingleSelect = ({
  options,
  label,
  value,
  onChange,
  loading,
  selectWidth = true,
}: SingleSelectProps) => {
  return (
    <Row className="align-center single-select position-relative">
      <span className="position-absolute z-100 label">{label}:</span>
      <Select
        options={options}
        value={value}
        onChange={onChange}
        loading={loading}
        dropdownMatchSelectWidth={selectWidth}
      />
    </Row>
  );
};
